import React, { useState, useEffect, useRef } from 'react';

const AnimatedCounter = ({ value, duration = 1000, prefix = '', suffix = '', decimals = 0, className = '' }) => {
  const [display, setDisplay] = useState(0);
  const startRef = useRef(null);
  const prevValue = useRef(0);

  useEffect(() => {
    const start = prevValue.current;
    const diff = value - start;
    if (diff === 0) return;
    const startTime = performance.now();
    prevValue.current = value;

    const animate = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(start + diff * eased);
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [value, duration]);

  const formatted = display.toFixed(decimals);
  return <span className={className}>{prefix}{formatted}{suffix}</span>;
};

export default AnimatedCounter;
